import { useFocusRange, useFormatZoned } from "utils/customHooks/genericHooks";
import { FORMAT_READABLE_DATE_WITH_SHORT_DAY } from "utils/timeUtils";
import styled from "styled-components/macro";

const StyledH2 = styled.h2`
  margin: auto;
  width: fit-content;
  font-size: 1.5em;
`;
export function SimpleDateRange() {
  const focusRange = useFocusRange();
  const formatZoned = useFormatZoned();

  if (!focusRange) {
    return null;
  }
  const startDate = formatZoned(
    focusRange.ge,
    FORMAT_READABLE_DATE_WITH_SHORT_DAY
  );
  const endDate = formatZoned(
    focusRange.lt,
    FORMAT_READABLE_DATE_WITH_SHORT_DAY
  );
  return (
    <StyledH2>
      {startDate} - {endDate}
    </StyledH2>
  );
}
